import { AccountDashboardTheme } from '@copilot/common/config';
import { OrgRoleTitles } from '@copilot/common/store/models/const/enum';
import HeaderSiderLayout from '@copilot/common/pages/layouts/headerSider';
import { AccountDashboardHeaderContainer } from '@copilot/common/pages/layouts/headerSider/header/accountDashboardHeader';
import { AccountDashboardSidebar } from '@copilot/common/pages/layouts/headerSider/sidebar/accountDashboardSidebar';
import RouteWithPermissions from '@copilot/common/router/routeWithPermissions';
import { AuthenticatedTemplate } from '@copilot/common/utils/authenticationProvider';
import { ConfigProvider } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { withLazyComponent } from './routerHelpers';

/**
 * Router for the accounts dashboard sub-app
 * @param roleReq - The role requirements for the router
 * @returns The accounts dashboard router
 */
export function AccountsDashboardRouter({ roleReq }: { roleReq: OrgRoleTitles[] }) {
    const AccountDashboardPage = withLazyComponent(
        lazy(() => import('@copilot/common/pages/accountDashboard/accountDashboardPage'))
    );
    const AccountDetailPage = withLazyComponent(
        lazy(() => import('@copilot/common/pages/accountDetailsPage/accountDetailsPage'))
    );

    const AccountCampaignsProspecting = withLazyComponent(
        lazy(() => import('@copilot/common/pages/accountCampaigns/accountCampaignsProspecting'))
    );
    const AccountCampaignsNurture = withLazyComponent(
        lazy(() => import('@copilot/common/pages/accountCampaigns/accountCampaignsNurture'))
    );

    return (
        <>
            <ConfigProvider prefixCls="copilot" theme={AccountDashboardTheme}>
                <AuthenticatedTemplate>
                    <HeaderSiderLayout>
                        <HeaderSiderLayout.Header>
                            <AccountDashboardHeaderContainer />
                        </HeaderSiderLayout.Header>
                        <HeaderSiderLayout.Sider>
                            <AccountDashboardSidebar />
                        </HeaderSiderLayout.Sider>
                        <HeaderSiderLayout.Content>
                            <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <RouteWithPermissions
                                            element={<AccountDashboardPage />}
                                            allowedRoles={roleReq}
                                        />
                                    }
                                />
                                <Route
                                    path="/campaigns-prospecting/:view?"
                                    element={
                                        <RouteWithPermissions
                                            element={<AccountCampaignsProspecting />}
                                            allowedRoles={roleReq}
                                        />
                                    }
                                />
                                <Route
                                    path="/campaigns-nurture/:view?"
                                    element={
                                        <RouteWithPermissions
                                            element={<AccountCampaignsNurture />}
                                            allowedRoles={roleReq}
                                        />
                                    }
                                />
                                <Route
                                    path="/:accountId"
                                    element={
                                        <RouteWithPermissions
                                            element={<AccountDashboardPage />}
                                            allowedRoles={roleReq}
                                        />
                                    }
                                />
                                <Route
                                    path="/:accountId/details"
                                    element={
                                        <RouteWithPermissions
                                            element={<AccountDetailPage />}
                                            allowedRoles={roleReq}
                                        />
                                    }
                                />
                                <Route
                                    path="/:parentAccountId/:accountId/details"
                                    element={
                                        <RouteWithPermissions
                                            element={<AccountDetailPage />}
                                            allowedRoles={roleReq}
                                        />
                                    }
                                />
                            </Routes>
                        </HeaderSiderLayout.Content>
                    </HeaderSiderLayout>
                </AuthenticatedTemplate>
            </ConfigProvider>
        </>
    );
}
